import * as React from 'react';
import ReactDOM from 'react-dom';
import TagManager from 'react-gtm-module-nonce';

import { constants } from 'utils';

import App from './App';
import reportWebVitals from './reportWebVitals';

// https://github.com/welldone-software/why-did-you-render#installation
// https://github.com/welldone-software/why-did-you-render#usage
if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const whyDidYouRender = require('@welldone-software/why-did-you-render');
  whyDidYouRender(React);
}

if (process.env.NODE_ENV === 'production') {
  const __webpack_nonce__ = constants.nonce;

  const tagManagerArgs = {
    gtmId: process.env.REACT_APP_GTMID,
    nonce: __webpack_nonce__
  };

  TagManager.initialize(tagManagerArgs);
}

ReactDOM.render(<App />, document.getElementById('root'));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
